<div class="customer-step">
  <h3 class="step-title">Select Customer</h3>

  @if (state.isLoading()) {
    <div class="loading-container">
      <img src="assets/gif/loader/loader.gif" alt="Loading..." class="gif-loader" />
      <p>{{ state.isMatching() ? 'Finding matches...' : 'Loading...' }}</p>
    </div>
  } @else if (state.error()) {
    <div class="error-container">
      <i class="material-symbols-rounded">error</i>
      <span>{{ state.error() }}</span>
    </div>
  } @else {
    @if (state.customerOptions().length > 1) {
      <p class="step-description">I found multiple potential matches. Please select the correct customer or create a new one.</p>
    } @else {
      <p class="step-description">I couldn't find any existing customer records matching your bills. We'll create a new customer record for you.</p>
    }

    <!-- Customer Cards -->
    <div class="customer-cards">
      @for (option of state.customerOptions(); track option.value) {
        <div class="customer-card-wrapper">
          <button
            class="customer-card"
            [class.selected]="state.selectedCustomerId() === option.value"
            [class.create-new]="option.isCreateNew"
            (click)="selectCustomer(option.value, option.isCreateNew ? newCustomerPreview.suggestedName : option.label)">
            <div class="card-radio">
              <mat-radio-button
                [checked]="state.selectedCustomerId() === option.value"
                [value]="option.value"
                disableRipple
              ></mat-radio-button>
            </div>
            <div class="card-content">
              @if (option.isCreateNew) {
                <div class="card-icon create-new-icon">
                  <i class="material-symbols-rounded">add_business</i>
                </div>
                <div class="card-detail">
                  <span class="card-name">Create New Customer</span>
                  <span class="card-sub">All entities will be created fresh</span>
                </div>
              } @else {
                <div class="card-icon match-icon">
                  <i class="material-symbols-rounded">language</i>
                </div>
                <div class="card-detail">
                  <span class="card-name">{{ option.label }}</span>
                  <span class="card-sub">
                    <span class="match-score">{{ (option.score! * 100) | number:'1.0-0' }}% match</span>
                  </span>
                </div>
              }
            </div>
          </button>

          <!-- Detail panel for selected option -->
          @if (state.selectedCustomerId() === option.value) {
            <div class="card-detail-panel">
              @if (option.isCreateNew) {
                <div class="detail-row">
                  <i class="material-symbols-rounded detail-icon">badge</i>
                  <span class="detail-label">Name</span>
                  <span class="detail-value">{{ newCustomerPreview.suggestedName }}</span>
                </div>
                @if (newCustomerPreview.billingAddress) {
                  <div class="detail-row">
                    <i class="material-symbols-rounded detail-icon">mail</i>
                    <span class="detail-label">Billing Address</span>
                    <span class="detail-value">{{ newCustomerPreview.billingAddress }}</span>
                  </div>
                }
                <div class="detail-row">
                  <i class="material-symbols-rounded detail-icon">account_balance</i>
                  <span class="detail-label">Legal Entities</span>
                  <span class="detail-value">{{ newCustomerPreview.legalEntityNames.join(', ') }}</span>
                </div>
                <div class="detail-counts">
                  <span class="detail-count">
                    <i class="material-symbols-rounded">home_work</i>
                    {{ newCustomerPreview.serviceAddressCount }} {{ newCustomerPreview.serviceAddressCount === 1 ? 'address' : 'addresses' }}
                  </span>
                  <span class="detail-count">
                    <i class="material-symbols-rounded">speed</i>
                    {{ newCustomerPreview.meterCount }} {{ newCustomerPreview.meterCount === 1 ? 'meter' : 'meters' }}
                  </span>
                  <span class="detail-count">
                    <i class="material-symbols-rounded">receipt_long</i>
                    {{ newCustomerPreview.billCount }} {{ newCustomerPreview.billCount === 1 ? 'bill' : 'bills' }}
                  </span>
                </div>
              } @else {
                @if (option.matchReasons && option.matchReasons.length > 0) {
                  <div class="match-reasons">
                    <span class="reasons-label">Matched because:</span>
                    @for (reason of option.matchReasons; track reason) {
                      <span class="reason-chip">
                        <i class="material-symbols-rounded">check_circle</i>
                        {{ reason }}
                      </span>
                    }
                  </div>
                }
              }
            </div>
          }
        </div>
      }
    </div>

    <!-- Actions -->
    <div class="actions-bar">
      <button class="btn-secondary" (click)="goBack()" [disabled]="isCreatingCustomer">
        <i class="material-symbols-rounded">arrow_back</i>
        Back
      </button>
      <button
        class="btn-primary"
        (click)="confirmCustomer()"
        [disabled]="state.selectedCustomerId() === undefined || isCreatingCustomer">
        @if (isCreatingCustomer) {
          <mat-spinner diameter="18"></mat-spinner>
          Creating Customer...
        } @else {
          Continue
          <i class="material-symbols-rounded">arrow_forward</i>
        }
      </button>
    </div>
  }
</div>
